"use client"

import { useEffect, useRef, useState } from 'react'

import SvgIcon from '@components/shared/svg-icons/SvgIcon'

// Przełącza zwinięcie artykułu (klasa na kontenerze z serwera). Fokus wchodzący
// do niewidocznej części (np. link z CMS) rozwija artykuł.
export default function SeoMore ({ bodyId, className, clampedClass, labels }) {
    const [open, setOpen] = useState(false)
    const btnRef = useRef(null)

    useEffect(() => {
        const body = document.getElementById(bodyId)
        if (!body) return
        body.classList.toggle(clampedClass, !open)
        const onFocus = () => setOpen(true)
        if (!open) body.addEventListener('focusin', onFocus)
        return () => body.removeEventListener('focusin', onFocus)
    }, [bodyId, clampedClass, open])

    const toggle = () => {
        setOpen(o => !o)
        if (open) requestAnimationFrame(() => btnRef.current?.scrollIntoView({ block: 'nearest' }))
    }

    return (
        <button aria-controls={bodyId} aria-expanded={open} className={className} onClick={toggle} ref={btnRef} type="button">
            {open ? labels.less : labels.more}
            <SvgIcon name="down" size="sm" />
        </button>
    )
}
